// Favorite-team picker options for registration — the 48 teams of the 2026
// FIFA World Cup. `countryCode` is a circle-flag code (ISO 3166-1 alpha-2,
// plus gb-eng / gb-sct), resolved to a local SVG under public/images/flags.
// Names mirror the keys in utils/countryDict.ts so flags resolve consistently.
const countryArray = [
  // Hosts
  { countryName: "USA", countryCode: "us" },
  { countryName: "Canada", countryCode: "ca" },
  { countryName: "Mexico", countryCode: "mx" },

  // UEFA
  { countryName: "Spain", countryCode: "es" },
  { countryName: "France", countryCode: "fr" },
  { countryName: "England", countryCode: "gb-eng" },
  { countryName: "Portugal", countryCode: "pt" },
  { countryName: "Netherlands", countryCode: "nl" },
  { countryName: "Belgium", countryCode: "be" },
  { countryName: "Germany", countryCode: "de" },
  { countryName: "Croatia", countryCode: "hr" },
  { countryName: "Switzerland", countryCode: "ch" },
  { countryName: "Austria", countryCode: "at" },
  { countryName: "Norway", countryCode: "no" },
  { countryName: "Sweden", countryCode: "se" },
  { countryName: "Scotland", countryCode: "gb-sct" },
  { countryName: "Czechia", countryCode: "cz" },
  { countryName: "Türkiye", countryCode: "tr" },
  { countryName: "Bosnia", countryCode: "ba" },

  // CONMEBOL
  { countryName: "Argentina", countryCode: "ar" },
  { countryName: "Brazil", countryCode: "br" },
  { countryName: "Uruguay", countryCode: "uy" },
  { countryName: "Colombia", countryCode: "co" },
  { countryName: "Ecuador", countryCode: "ec" },
  { countryName: "Paraguay", countryCode: "py" },

  // CONCACAF
  { countryName: "Panama", countryCode: "pa" },
  { countryName: "Haiti", countryCode: "ht" },
  { countryName: "Curaçao", countryCode: "cw" },

  // AFC
  { countryName: "Japan", countryCode: "jp" },
  { countryName: "South Korea", countryCode: "kr" },
  { countryName: "Iran", countryCode: "ir" },
  { countryName: "Australia", countryCode: "au" },
  { countryName: "Saudi Arabia", countryCode: "sa" },
  { countryName: "Qatar", countryCode: "qa" },
  { countryName: "Uzbekistan", countryCode: "uz" },
  { countryName: "Jordan", countryCode: "jo" },
  { countryName: "Iraq", countryCode: "iq" },

  // CAF
  { countryName: "Morocco", countryCode: "ma" },
  { countryName: "Senegal", countryCode: "sn" },
  { countryName: "Tunisia", countryCode: "tn" },
  { countryName: "Egypt", countryCode: "eg" },
  { countryName: "Algeria", countryCode: "dz" },
  { countryName: "Ivory Coast", countryCode: "ci" },
  { countryName: "Ghana", countryCode: "gh" },
  { countryName: "Cape Verde", countryCode: "cv" },
  { countryName: "South Africa", countryCode: "za" },
  { countryName: "DR Congo", countryCode: "cd" },

  // OFC
  { countryName: "New Zealand", countryCode: "nz" },
];

export default countryArray.sort((a, b) =>
  a.countryName < b.countryName ? -1 : 1
);
